export type GradientPreset = 'brand' | 'sunset' | 'ocean' | 'aurora' | 'citrus'

export const gradientPresets: Record<GradientPreset, { from: string; to: string }> = {
  brand: { from: 'var(--nexus-purple)', to: 'var(--nexus-pink)' },
  sunset: { from: 'var(--nexus-pink)', to: 'var(--nexus-yellow)' },
  ocean: { from: 'var(--nexus-blue)', to: 'var(--nexus-green)' },
  aurora: { from: 'var(--nexus-purple)', to: 'var(--nexus-blue)' },
  citrus: { from: 'var(--nexus-yellow)', to: 'var(--nexus-green)' },
}
